<template>
    <card-grid
        ref="grid"
        :button-toolbar-class="[]"
        :is-search="false"
        :key="cardGridKey"
        :pagination="true"
        :fetchCallback="gridFetchCallback"
        :columnDefs="columnDefs"
        :pagination-page-size="limit"
        :cache-block-size="limit"
        :font-size="tabWidget.settings.table_font_size"
    >
    </card-grid>
</template>

<script>
import ActionsCellRenderer from './reservations-actions-cell-renderer.vue';
import API from '../../../../api';
import CardGrid from '../../../generic/card-grid/card-grid.vue';
import GuestCellRenderer from './guest-cell-renderer.vue';
import { mapGetters } from 'vuex';

export default {
    props: {
        getDataEndpoint: {
            type: String,
            required: true,
        },
        tabWidget: Object,
        cardGridKey: Number,
        limit: Number,
        hideEnteredColumn: Boolean,
    },
    components: {
        CardGrid,
        actionsCellRenderer: ActionsCellRenderer,
        guestCellRenderer: GuestCellRenderer,
    },
    data() {
        return {
            offset: 0,
            sort: 'id',
            desc: false,
            search: '',
        };
    },
    computed: {
        ...mapGetters('header', ['userPermissions']),
        gridFetchCallback() {
            return ({ offset, sort, desc }) => {
                this.offset = offset;
                this.sort = sort;
                this.desc = desc;
                return API.get(this.getDataEndpoint, {
                    params: {
                        limit: this.limit,
                        offset: this.offset,
                        desc: this.desc,
                        sort: this.sort,
                        with_airbnb:
                            this.tabWidget.settings.display_airbnb_reservations,
                        hide_older_than_days: this.tabWidget.settings.hide_older_than_days,
                    },
                });
            };
        },
        columnDefs() {
            return [
                {
                    field: 'booking_method_name',
                    headerName: '',
                    maxWidth: 60,
                    sortable: false,
                    cellRenderer: ({ data }) =>
                        data &&
                        `<img src="${data.booking_method_icon_url}" title="${data.display_booking_method_name}" />`,
                },
                {
                    field: 'entered',
                    type: 'dateColumn',
                    headerName: 'Entered date',
                    minWidth: 160,
                    sort: 'desc',
                    hide: this.hideEnteredColumn,
                },
                {
                    field: 'user.short_name',
                    headerName: 'Guest',
                    headerClass: 'guest-name-status-column',
                    cellRenderer: 'guestCellRenderer',
                    cellRendererParams: {
                        getReservation({ data }) {
                            return data;
                        },
                    },
                    minWidth: 200,
                },
                {
                    field: 'id',
                    headerName: 'Invoice ID',
                    cellRenderer: ({ data }) => {
                        const reservation = data;
                        if (reservation) {
                            if (this.userPermissions?.can_view_invoices) {
                                return `<a href="/app/reservation/edit/invoice/${reservation.id}">${reservation.id}</a>`;
                            }
                            return `${reservation.id}`;
                        }
                    },
                    minWidth: 150,
                },
                {
                    field: 'property_name',
                    headerName: 'Property',
                    sortable: false,
                    minWidth: 350,
                },
                {
                    field: 'from_date',
                    type: 'dateColumn',
                    headerName: 'Start Date',
                    minWidth: 160,
                },
                {
                    field: 'to_date',
                    type: 'dateColumn',
                    headerName: 'End Date',
                    minWidth: 160,
                },
                {
                    field: 'current_balance',
                    type: 'amountColumn',
                    headerName: 'Total',
                    cellRendererParams: {
                        noNegative: true,
                    },
                },
                {
                    field: '',
                    headerName: '',
                    minWidth: 120,
                    maxWidth: 120,
                    sortable: false,
                    cellRenderer: 'actionsCellRenderer',
                    cellClass: 'reservations-actions',
                    cellRendererParams: {
                        update: () => {
                            this.$refs.grid.refreshServerSide();
                        },
                    },
                },
            ];
        },
    },
    methods: {},
};
</script>


<style lang="scss">
.reservations-actions {
    display: flex;
    justify-content: center !important;
}
</style>
